module.exports = __webpack_public_path__ + "static/media/overta.d5a94bb1.m4a";